import styled from "styled-components";

export const Wrapper = styled.footer`
  text-align: center;
`;
